import { FC } from "react";
import { Box, Paper, useTheme } from "@mui/material";
import { ChangeCircle } from "@mui/icons-material";
import { HighlightForOptions, useAppDataContext } from "@context/AppContext";
import HighlightAutomatic from "../custom-icons/HighlightAutomatic";
import HighlightSetter from "../custom-icons/HighlightSetter";
import GameCaptain from "../custom-icons/GameCaptain";
import AppVersion from "../AppVersion";
import { gameState } from "@/services/gameState";
import ActionButton, { ActionButtonWithRipple } from "../buttons/ActionButton";
import ToggleActionButtonGroup from "../buttons/ToggleActionButtonGroup";
import GameEventLogDialog from "../event-history/GameEventLogDialog";

const RefereeTabletActionButtons: FC = () => {
  const {
    setUseHighlightFor,
    setHighlightSetterAutomatically,
    setUseFirstRefPerspective,
    useHighlightFor,
    highlightSetterAutomatically,
    useFirstRefPerspective,
  } = useAppDataContext();

  const gender = gameState("gender");
  const isSetterPlayerKnown = gameState("isSetterPlayerKnown");

  const { palette } = useTheme();

  const toggleUseFirstRefPov = () =>
    setUseFirstRefPerspective(!useFirstRefPerspective);

  const toggleHighlightSetterAutomatically = () => {
    const newValue = !highlightSetterAutomatically;
    if (newValue && useHighlightFor === "setter") {
      setUseHighlightFor("gameCaptain");
    }
    setHighlightSetterAutomatically(newValue);
  };

  return (
    <Paper elevation={7} square>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        width={"100%"}
        gap={1}
      >
        <GameEventLogDialog showFilterButton={true} />

        <ActionButtonWithRipple
          onClick={toggleHighlightSetterAutomatically}
          label={`Autom. Steller: ${isSetterPlayerKnown && highlightSetterAutomatically ? "AKTIV" : "deaktiviert"}`}
          disabled={!isSetterPlayerKnown}
        >
          <HighlightAutomatic
            color={
              !isSetterPlayerKnown
                ? palette.text.disabled
                : highlightSetterAutomatically
                  ? palette.success.main
                  : palette.text.primary
            }
          />
        </ActionButtonWithRipple>

        <ToggleActionButtonGroup
          buttons={[
            {
              icon: GameCaptain,
              id: "gameCaptain",
              label: gender === "FEMALE" ? "Kapitänin" : "Kapitän",
            },
            {
              icon: HighlightSetter,
              id: "setter",
              label: gender === "FEMALE" ? "Stellerin" : "Steller",
              disabled: isSetterPlayerKnown && highlightSetterAutomatically,
            },
          ]}
          selectedId={
            isSetterPlayerKnown && highlightSetterAutomatically
              ? "gameCaptain"
              : useHighlightFor
          }
          onSelectedIdChange={(newId) => {
            setUseHighlightFor(newId as HighlightForOptions);
          }}
          selectedValuePrefix={"Markierung: "}
          hideButtonLabels={true}
          showSelectedValue={true}
          sx={{ flex: 1 }}
        />
        <ActionButton
          onClick={toggleUseFirstRefPov}
          label={`Ansicht ${useFirstRefPerspective ? "1. SR" : "2.SR"}`}
        >
          <ChangeCircle />
        </ActionButton>
      </Box>
      <AppVersion px={2} showAlwaysOnState={true} />
    </Paper>
  );
};

export default RefereeTabletActionButtons;
